import { useLanguage } from '../../context/LanguageContext';
import { TEMPLATES } from './PosterPreview';
import styles from './Share.module.css';

/**
 * 模板选择器组件
 * 提供三种海报风格选择
 */
export default function TemplateSelector({ selectedTemplate, onSelect }) {
    const { language } = useLanguage();

    const templates = Object.values(TEMPLATES);

    return (
        <div className={styles.templateSelector}>
            <h4 className={styles.selectorTitle}>
                {{ zh: '选择海报风格', en: 'Choose Style', de: 'Stil wählen' }[language] || 'Choose Style'}
            </h4>
            <div className={styles.templateGrid}>
                {templates.map(template => (
                    <button
                        key={template.id}
                        className={`${styles.templateOption} ${
                            selectedTemplate === template.id ? styles.selected : ''
                        }`}
                        onClick={() => onSelect(template.id)}
                        style={{
                            background: template.background,
                            borderColor: selectedTemplate === template.id
                                ? template.accent
                                : 'transparent'
                        }}
                    >
                        <span
                            className={styles.templateIcon}
                            style={{ color: template.accent }}
                        >
                            {template.id === 'wild' && '🔥'}
                            {template.id === 'classic' && '🌟'}
                            {template.id === 'tech' && '❄️'}
                        </span>
                        <span
                            className={styles.templateName}
                            style={{ color: template.textColor }}
                        >
                            {template.name[language] || template.name.en}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
}
